import React, { FC } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import { Coverage } from '../../../../types/FHIRTypes/Coverage'
import HumanName from '../../DataTypes/HumanName'
import client_logo from '../../../../assets/customizations/logos/client_banner.svg'
import ConnectID_QR from '../../../../assets/images/ConnectID_QR.svg'
import { Patient } from '../../../../types/FHIRTypes/Patient'

import './index.scss'

type DigitalIdCardProps = {
  coverageData?: { entry: { resource: Coverage }[] }
  patientData?: Patient
  isFetching: boolean
}

const DigitalIdCard: FC<DigitalIdCardProps> = ({ patientData }) => {

  return (
    <>
      <div className='m-auto p-2 dataContainer'>
        <div className='p-1'>
          <Row className='align-items-center justify-content-between'>
            <Col xs={12} sm={8} className='text-center text-sm-start'>
              <h3 className='mb-2 fw-bold'>
                {patientData?.name && <HumanName data={patientData?.name?.[0]} dataExtension={patientData?._name} />}
              </h3>
            </Col>
            <Col xs={12} sm={4} className='text-center text-sm-end'>
              <Image className='img-fluid px-2' src={client_logo} alt="Provider" />
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={9}>
              <div className='type-pair'>
                <div className='element-label'>
                  <strong>ID </strong>
                </div>
                308fead6cc51941
              </div>
              <div className='type-pair'>
                <div className='element-label'>
                  <strong>Group </strong>
                </div>
                FAMILYCARE
              </div>
              <div className='type-pair'>
                <div className='element-label'>
                  <strong>Health Plan </strong>
                </div>
                FC WAIVER - DUAL ELIGIBLE
              </div>
            </Col>
            <Col xs={12} sm={3}>
              <div className='element-label'>
                <strong>Effective </strong>
              </div>
              02/28/2018
            </Col>
          </Row>
          <div className='text-center text-sm-start footer'>
            <hr />
            <Image className='img-fluid qr-code' src={ConnectID_QR} alt="ConnectID QR Code" />
          </div>
        </div>
        308fead6cc51941
      </div>
    </>
  )
}

export default DigitalIdCard